module.exports = __webpack_public_path__ + "img/hakuna_bg06.9ca0c50a.jpg";